var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultOfficialAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#EFF3F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24008_95087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 31.7288L49.9987 13L82 31.7262L49.9935 50.537L18 31.7288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9935 50.5367L18 31.7285V69.1491L49.9935 87.9997V50.5367Z",
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9935 50.5367L18 31.7285V69.1491L49.9935 50.5367Z",
    fill: "#E8ECF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9974 50.5367L81.9909 31.7285V69.1491L49.9922 87.9997L49.9974 50.5367Z",
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 50.5367L81.9935 31.7285V69.1491L50 50.5367Z",
    fill: "#D6D9E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0859 40.0099L49.9957 29.5273L68.0279 40.0813L49.9905 50.6856L32.0859 40.0099Z",
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9957 50.5373L32.0859 40.0098V66.0031L42.5518 71.8729L49.9957 67.4745V50.5373Z",
    fill: "#D6D9E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9935 63.5234L42.5625 59.3076V71.8253L49.9935 67.4745V63.5234Z",
    fill: "#E8ECF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9922 50.5373L67.8994 40.0098V66.0031L57.4362 71.8729L49.9922 67.4745V50.5373Z",
    fill: "#E8ECF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9922 63.5234L57.4232 59.3076V71.8253L49.9922 67.4745V63.5234Z",
    fill: "#D6D9E3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24008_95087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 75,
    fill: "white",
    transform: "translate(18 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultOfficialAccount);
export default __webpack_public_path__ + "static/media/default-official-account.13534d219751131ef06e412f75923a7e.svg";
export { ForwardRef as ReactComponent };